export default {
  /************** 数字处理util *****************/
  numUtil() {
    let self = this;
    return {
      test() {
        self.alert();
      },
      isNum(s) {
        s = `${s}`;
        // if (typeof s !== 'number') {
        //   return false
        // }
        if (!isNaN(s)) {
          return true;
        } else {
          return false;
        }
      },
      float(s, l) {
        s = `${s}`;
        if (!this.isNum(s)) {
          return 0;
        }
        if (!l) {
          return parseFloat(s);
        }
        return parseFloat(s).toFixed(l);
      },
      int(s) {
        s = `${s}`;
        if (!this.isNum(s)) {
          return 0;
        }
        return parseInt(s);
      }
    };
  },
  pageUtil() {
    let self = this;
    return {
      cal(page) {
        page.pages = Math.floor((page.total - 1) / page.pageSize) + 1;
      },
      plus(page) {
        this.calPage(page);
        if (page.currentPage < page.pages) {
          page.currentPage++;
          return true;
        }
        return false;
      },
      reduce(page) {
        this.calPage(page);
        if (page.currentPage > 1) {
          page.currentPage--;
          return true;
        }
        return false;
      }
    };
  },
  /*********** 数组处理Util ***************/
  arrUtil() {
    let self = this;
    return {
      contains(it, arr) {
        for (let a of arr) {
          if (it === a) {
            return true;
          }
        }
        return false;
      },
      remove(it, arr) {
        let i = 0;
        for (let a of arr) {
          if (a === it) {
            arr.splice(i, 1);
            return a;
          }
          i++;
        }
        return null;
      },
      isEmpty(arr) {
        if (!arr || arr.length <= 0) {
          return true;
        }
        return false;
      },
      isNotEmpty(arr) {
        return !this.isEmpty(arr);
      },
      onlyOne(arr) {
        return this.isNotEmpty(arr) && arr.length === 1;
      },
      atLeastOne(arr) {
        return this.isNotEmpty(arr) && arr.length > 0;
      }
    };
  },
  /*************** loading效果 *********/
  loading() {
    let self = this;
    return {
      show() {
        /* return self.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        }); */
        let loading = document.getElementById("loading");
        loading.style =
          "background:#808080;opacity:0.5;position:absolute;top:0;right:0;bottom:0;left:0;display:block;";
      },
      close() {
        /* if (!loading) {
          return;
        }
        setTimeout(() => {
          loading.close();
        }, 200); */
        let loading = document.getElementById("loading");
        loading.style = "display:none;";
      }
    };
  },
  //获取当前时间的前后日期 +为前 -为后
  ShowDate(date) {
    var num = date;
    let n = num;
    let d = new Date();
    let year = d.getFullYear();
    let mon = d.getMonth() + 1;
    let day = d.getDate();
    if (day <= n) {
      if (mon > 1) {
        mon = mon - 1;
      } else {
        year = year - 1;
        mon = 12;
      }
    }
    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    let s =
      year +
      "-" +
      (mon < 10 ? "0" + mon : mon) +
      "-" +
      (day < 10 ? "0" + day : day);
    return s;
  },
  //比较2个时间大小
  compare(date1, date2) {
    let dates1 = new Date(date1);
    let dates2 = new Date(date2);
    if (dates1 > dates2) {
      return true;
    } else {
      return false;
    }
  },
  checkTaxpayerId(taxpayerId) {
    if (taxpayerId != "" && taxpayerId.length === 15) {
      var addressCode = taxpayerId.substring(0, 6);
      // 校验地址码
      var check = this.checkAddressCode(addressCode);
      if (!check) {
        return false;
      }
      // 校验组织机构代码
      var orgCode = taxpayerId.substring(6, 9);
      check = this.isValidOrgCode(orgCode);
      if (!check) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  },
  isValidOrgCode(value) {
    if (value != "") {
      var part1 = value.substring(0, 8);
      var part2 = value.substring(value.length - 1, 1);
      var ws = [3, 7, 9, 10, 5, 8, 4, 2];
      var str = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var reg = /^([0-9A-Z]){8}$/;
      if (!reg.test(part1)) {
        return true;
      }
      var sum = 0;
      for (var i = 0; i < 8; i++) {
        sum += str.indexOf(part1.charAt(i)) * ws[i];
      }
      var C9 = 11 - (sum % 11);
      var YC9 = part2 + "";
      if (C9 == 11) {
        C9 = "0";
      } else if (C9 == 10) {
        C9 = "X";
      } else {
        C9 = C9 + "";
      }
      return YC9 != C9;
    }
  },
  checkAddressCode(addressCode) {
    var provinceAndCitys = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外"
    };
    var check = /^[1-9]\d{5}$/.test(addressCode);
    if (!check) return false;
    if (provinceAndCitys[parseInt(addressCode.substring(0, 2))]) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 验证电话号码（手机号码+电话号码）
   * @param obj
   * @returns {Boolean}
   */
  checkPhoneNum(obj) {
    if (/^((\d{3}-\d{8}|\d{4}-\d{7,8})|(1[3|5|7|8][0-9]{9}))$/.test(obj)) {
      return true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/custom-util.js